import React, { FC, useEffect, useState } from 'react';
import { Col, message, Row, Select } from 'antd';
import { useNavigate } from 'react-router-dom';
import { api, endpoints } from '../../api';
import {
  BlueLayout,
  CustomButton,
  CustomSelect,
  FormBlock,
  FormInput,
  FormItem,
  GridItem,
  PagesContainerUI,
  ValidatorFormItem,
} from '../../styles/styled';
import { addressRegExp, emailRegExp, fioRegExp, onlyLettersRegExp } from '../../utils/patterns';
import { sortRegions } from '../../utils/sortObject';
import { RegionsType } from '../ExpertPage/types';
import { PovsType } from '../PovsLkPage/types';
import { PovsMemberInputType } from './types';

const { Option } = Select;

type CreatePovsPageProps = {
  edit?: boolean;
  currentPovs?: PovsType | null;
  povsId?: string;
  refresh?: () => Promise<void>;
  noAdd?: boolean;
};

export const CreatePovsPage: FC<CreatePovsPageProps> = ({ refresh, edit, noAdd, currentPovs, povsId }) => {
  const [regionsList, setRegions] = useState<RegionsType>([]);
  const [povInputState, setPovInput] = useState<PovsMemberInputType>(
    edit
      ? {
          region: { id: currentPovs?.region?.id },
          email: currentPovs?.email,
          povs: currentPovs?.povs,
        }
      : {},
  );
  const navigate = useNavigate();

  const [changesState, setChanges] = useState<PovsMemberInputType>({});
  //
  // useEffect(() => {
  //   if (edit) {
  //     setPovInput({
  //       ...povInputState,
  //       region: { id: currentPovs?.region?.id },
  //       email: currentPovs?.email,
  //       povs: currentPovs?.povs,
  //     });
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [edit]);

  useEffect(() => {
    (async () => {
      try {
        const regionsResponse = await api.get<RegionsType>(endpoints.getRegions());

        setRegions(regionsResponse.data.sort(sortRegions));
      } catch (err) {}
    })();
  }, []);

  const createPovs = () => {
    api
      .post(endpoints.postPovs(), { ...povInputState, enabled: true })
      .then(() => {
        navigate(-1);
        message.success('ПОВС успешно создан');
      })
      .catch(() => message.error('Произошла ошибка при создании ПОВС'));
  };

  const updatePovs = (id?: string) => {
    if (id) {
      api
        .put(
          endpoints.putExpert(id),
          Object.keys(changesState).includes('povs')
            ? {
                ...changesState,
                povs: { ...changesState?.povs, id: currentPovs?.povs?.id },
              }
            : changesState,
        )
        .then(() => refresh?.())
        .then(() => message.success('Данные успешно обновлены'))
        .catch(() => message.error('Ошибка при обновлении данных'));
    }

    return;
  };

  return (
    <PagesContainerUI>
      {!noAdd && <BlueLayout>Добавить повс</BlueLayout>}

      <FormBlock white padding="25px">
        <Row gutter={[20, 20]}>
          <Col span={8}>
            <ValidatorFormItem validator={!emailRegExp.test(povInputState?.email || '')} redstar>
              <div className="text">E-mail представителя</div>
              <FormInput
                value={povInputState?.email}
                onChange={(e) => {
                  setPovInput({ ...povInputState, email: e.target.value });
                  setChanges({ ...changesState, email: e.target.value });
                }}
              />
            </ValidatorFormItem>
          </Col>
          <Col span={8}>
            <ValidatorFormItem validator={!emailRegExp.test(povInputState?.povs?.email_gov || '')} redstar>
              <div className="text">E-mail органа власти</div>
              <FormInput
                value={povInputState?.povs?.email_gov}
                onChange={(e) => {
                  setPovInput({
                    ...povInputState,
                    povs: { ...povInputState?.povs, email_gov: e.target.value },
                  });
                  setChanges({
                    ...changesState,
                    povs: { ...changesState?.povs, email_gov: e.target.value },
                  });
                }}
              />
            </ValidatorFormItem>
          </Col>
          <Col span={8}>
            <FormItem redstar>
              <div className="text">Регион</div>
              <CustomSelect
                value={regionsList.find((el) => el.id === povInputState?.region?.id)?.title}
                onChange={(value, option) => {
                  setPovInput({
                    ...povInputState,
                    region: {
                      id: parseInt(Object.values(option)[0] as string),
                    },
                  });
                  setChanges({
                    ...changesState,
                    region: {
                      id: parseInt(Object.values(option)[0] as string),
                    },
                  });
                }}
              >
                {regionsList.map((region) => {
                  return (
                    <Option key={region.id} value={region.title}>
                      {region.title}
                    </Option>
                  );
                })}
              </CustomSelect>
            </FormItem>
          </Col>
          <Col span={13}>
            <ValidatorFormItem validator={!onlyLettersRegExp.test(povInputState?.povs?.gov_name || '')} redstar>
              <div className="text">Наименование органа власти</div>
              <FormInput
                value={povInputState?.povs?.gov_name}
                onChange={(e) => {
                  setPovInput({
                    ...povInputState,
                    povs: { ...povInputState?.povs, gov_name: e.target.value },
                  });
                  setChanges({
                    ...changesState,
                    povs: { ...changesState?.povs, gov_name: e.target.value },
                  });
                }}
              />
            </ValidatorFormItem>
          </Col>
          <Col span={13}>
            <ValidatorFormItem
              overLength={povInputState?.povs?.gov_loc ? povInputState.povs.gov_loc.length > 255 : false}
              validator={!addressRegExp.test(povInputState?.povs?.gov_loc || '')}
              redstar
            >
              <div className="text">Адрес нахождения органа власти</div>
              <FormInput
                value={povInputState?.povs?.gov_loc}
                onChange={(e) => {
                  setPovInput({
                    ...povInputState,
                    povs: { ...povInputState?.povs, gov_loc: e.target.value },
                  });
                  setChanges({
                    ...changesState,
                    povs: { ...changesState?.povs, gov_loc: e.target.value },
                  });
                }}
              />
            </ValidatorFormItem>
          </Col>
          <Col span={13}>
            <ValidatorFormItem
              validator={povInputState?.povs?.gov_fio ? !fioRegExp.test(povInputState?.povs?.gov_fio || '') : false}
              redstar
            >
              <div className="text">ФИО руководителя органа власти</div>
              <FormInput
                value={povInputState?.povs?.gov_fio}
                onChange={(e) => {
                  setPovInput({
                    ...povInputState,
                    povs: { ...povInputState?.povs, gov_fio: e.target.value },
                  });
                  setChanges({
                    ...changesState,
                    povs: { ...changesState?.povs, gov_fio: e.target.value },
                  });
                }}
              />
            </ValidatorFormItem>
          </Col>
        </Row>
        <GridItem align="center">
          <CustomButton onClick={() => (edit ? updatePovs(povsId) : createPovs())}>Сохранить</CustomButton>
        </GridItem>
      </FormBlock>
    </PagesContainerUI>
  );
};
